import { imagePreview } from "./img-preview";
import scroll from "./select-scroll"

export default {
  imagePreview,
  scroll
}